import { ContentWithEyeColumn } from 'components/TableColumn/ContentWithEyeColumn';
import { NameWithIdColumn } from 'components/TableColumn/NameWithIdColumn';
import { useMemo } from 'react';
import styles from './siteAnnouncementNameIdWithDetailColumn.module.scss';
import i18n from 'i18n';
import {
  SiteAnnouncement,
  SiteAnnouncementType
} from 'core/siteAnnouncement/SiteAnnouncement';
import { SiteAnnouncementTypeCapsule } from './SiteAnnouncementTypeCapsule';

const SiteAnnouncementCapsuleNameColumn: React.FC<{
  type: SiteAnnouncementType;
  id: number;
  name: string;
}> = ({ type, id, name }) => (
  <div className={styles.nameColumnWrapper}>
    <SiteAnnouncementTypeCapsule type={type} />
    <NameWithIdColumn id={id} name={name} clickable={false} />
  </div>
);

export const SiteAnnouncementNameIdWithDetailColumn: React.FC<{
  announcement: SiteAnnouncement;
  onShowDetail: (announcement: SiteAnnouncement) => void;
}> = ({ announcement, onShowDetail }) => {
  const tooltipProps = useMemo(
    () => ({
      id: `faEye-tooltip-${announcement.id}`,
      tooltip: i18n.t('siteAnnouncementList.buttons.showDetail')
    }),
    [announcement]
  );

  return (
    <div className={styles.siteAnnouncementNameIdWithDetailColumn}>
      <ContentWithEyeColumn
        value={announcement.id}
        onClickBtn={() => onShowDetail(announcement)}
        tooltipProps={tooltipProps}
        contentData={{
          component: SiteAnnouncementCapsuleNameColumn,
          props: {
            type: announcement.type,
            id: announcement.id,
            name: announcement.name
          }
        }}
      />
    </div>
  );
};

export const renderSiteAnnouncementNameIdWithDetailColumn =
  (onShowDetail: (announcement: SiteAnnouncement) => void) =>
  // eslint-disable-next-line react/display-name
  (announcement: SiteAnnouncement) => {
    return (
      <SiteAnnouncementNameIdWithDetailColumn
        announcement={announcement}
        onShowDetail={onShowDetail}
      />
    );
  };

export const SiteAnnouncementAdminNameColumn: React.FC<{
  announcement: SiteAnnouncement;
}> = ({ announcement }) => {
  return (
    <div className={styles.nameColumnWrapper}>
      <SiteAnnouncementTypeCapsule type={announcement.type} />
      <NameWithIdColumn
        id={announcement.id}
        name={announcement.name}
        clickUrl={`/site-announcements/${announcement.id}/edit`}
        clickable
      />
    </div>
  );
};

export const renderSiteAnnouncementAdminNameColumn = (
  announcement: SiteAnnouncement
) => {
  return <SiteAnnouncementAdminNameColumn announcement={announcement} />;
};
